import { render } from "./ProductDetailM.vue?vue&type=template&id=7a4437fc&scoped=true"
import script from "./ProductDetailM.vue?vue&type=script&lang=js"
export * from "./ProductDetailM.vue?vue&type=script&lang=js"

import "./ProductDetailM.vue?vue&type=style&index=0&id=7a4437fc&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a4437fc"]])

export default __exports__